export const getBatchesNew = async ({ page, pageSize, searchText = "" }) => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${process.env.REACT_APP_LIVE_URL}/adminPanel/getBatches?page=${page}&pageSize=${pageSize}&searchText=${searchText}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  if (!response.ok) throw new Error("Failed to fetch");

  return response.json();
};